import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const pdfColors = {
    text: "#1d2024",
    muted: "#66707a",
    border: "#d8dde2",
    headerFill: "#f1f4f6",
    surfaceAlt: "#f7f9fa",
    accent: "#237c63"
};

export const buildPdfTable = (headers, rows, widths, colors = pdfColors) => ({
    table: {
        headerRows: 1,
        widths,
        body: [
            headers.map((header) => ({
                text: header,
                bold: true,
                fillColor: colors.headerFill,
                color: colors.text,
                fontSize: 8,
                margin: [3, 4, 3, 4]
            })),
            ...rows
        ]
    },
    layout: {
        hLineColor: () => colors.border,
        vLineColor: () => colors.border,
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        paddingLeft: () => 3,
        paddingRight: () => 3,
        paddingTop: () => 3,
        paddingBottom: () => 3
    },
    margin: [0, 4, 0, 12]
});

export const buildPdfSectionTitle = (text, colors = pdfColors) => ({
    text,
    bold: true,
    fontSize: 11,
    color: colors.text,
    margin: [0, 12, 0, 4]
});

export const buildPdfKeyValue = (label, value, colors = pdfColors) => ({
    columns: [
        { text: label, color: colors.muted, fontSize: 8, width: 90 },
        { text: value || "-", color: colors.text, fontSize: 8, width: "*" }
    ],
    margin: [0, 1, 0, 1]
});

export const buildPdfKpiCard = (label, value, colors = pdfColors) => ({
    table: {
        widths: ["*"],
        body: [[
            {
                stack: [
                    { text: label, color: colors.muted, fontSize: 8, margin: [0, 0, 0, 3] },
                    { text: value || "-", color: colors.text, bold: true, fontSize: 12 }
                ],
                fillColor: colors.surfaceAlt || "#f7f9fa",
                margin: [8, 7, 8, 7]
            }
        ]]
    },
    layout: {
        hLineColor: () => colors.border,
        vLineColor: () => colors.border,
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5
    }
});

export const loadImageAsDataUrl = (imageSrc) => new Promise((resolve) => {
    if (!imageSrc) {
        resolve(null);
        return;
    }

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);
        resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = () => resolve(null);
    image.src = imageSrc;
});

export const downloadPdf = (docDefinition, fileName) => {
    pdfMake.createPdf(docDefinition).download(fileName);
};
